import { connect } from "vuex-connect";
import { ComicThumbnail } from "../../../components";

export default connect({
  stateToProps: {
    userThumbnailCroppedImageUrl: state =>
      state.myContents.userThumbnailCroppedImageUrl,
    isBusy: state => state.common.isBusy
  },
  gettersToProps: {
    thumbnailOriginalImageUrl: "myContents/thumbnailOriginalImageUrl",
    thumbnailCroppedImageUrl: "myContents/thumbnailCroppedImageUrl"
  },
  actionsToProps: {
    postThumbnailImage: (dispatch, value) =>
      dispatch("myContents/postUpdatedContentsThumbnail", value),
    deleteThumbnailImage: (dispatch, value) =>
      dispatch("myContents/deleteUpdatedContentsThumbnail", value)
  },
  mutationsToProps: {
    updateUserThumbnailOriginalImageUrl: (commit, value) =>
      commit("myContents/updateUserThumbnailOriginalImageUrl", value),
    updateDefaultThumbnailOriginalImageUrlQueryString: (commit, value) =>
      commit(
        "myContents/updateDefaultThumbnailOriginalImageUrlQueryString",
        value
      )
  }
})(ComicThumbnail.name + "-my-contents", ComicThumbnail);
